import "@fontsource/inter/400.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";

/** Police unique du calque vidéo composite (fichiers locaux, pas Google Fonts). */
export const COMPOSITE_FONT_FAMILY = "Inter, Arial, sans-serif";

let fontsReadyPromise = null;

/** Attend le chargement d’Inter avant html-to-image (évite les polices système aléatoires). */
export function ensureCompositeFontsReady() {
  if (typeof document === "undefined") return Promise.resolve();
  if (!fontsReadyPromise) {
    fontsReadyPromise = (async () => {
      try {
        if (document.fonts?.load) {
          await Promise.all([
            document.fonts.load("400 16px Inter"),
            document.fonts.load("700 16px Inter"),
            document.fonts.load("800 32px Inter"),
          ]);
        }
        if (document.fonts?.ready) await document.fonts.ready;
      } catch {
        /* repli Arial via COMPOSITE_FONT_FAMILY */
      }
    })();
  }
  return fontsReadyPromise;
}
